import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance_employee_document_id = get_axios_instance(api_variables.SERVICE_EMPLOYEE_DOCUMENTS_ID);
var axios_instance2 = get_axios_instance(api_variables.SERVICE_EMPLOYEE_UPDATE_DOCUMENTS);
var axios_instance_employee_delete = get_axios_instance(api_variables.SERVICE_EMPLOYEE_DELETE_DOCUMENTS);
var axios_instance_by_le_and_name = get_axios_instance(api_variables.SERVICE_EMPLOYEE_BY_LE_AND_NAME);
var axios_instance_by_installation = get_axios_instance(api_variables.SERVICE_EMPLOYEE_INSTALLATION);
var axios_instance_salary_revision = get_axios_instance(api_variables.SERVICE_GET_SALARY_REVISION)
var axios_instance_taxoutside = get_axios_instance(api_variables.SERVICE_EMPLOYEE_TAXOUTSIDE_FETCH)
var axios_instance_taxoutsideedit = get_axios_instance(api_variables.SERVICE_EMPLOYEE_TAXOUTSIDE_EDIT)
var axios_instance_taxoutsidedelete = get_axios_instance(api_variables.SERVICE_EMPLOYEE_TAXOUTSIDE_DELETE)
var axios_instance_by_installmentPatch=get_axios_instance(api_variables.SERVICE_EMPLOYEE_INSTALLMENTPATCH);
var axios_instance_employee_upload_document = get_axios_instance(api_variables.SERVICE_EMPLOYEE_UPLOAD_DOCUMENTS);

const _pk_name = "id";

//const employee_id = "f646be68-00a0-48aa-ae02-71c102668218";

const state = {
  data: {},
  exits: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },
  setExits: (state, payload) => {
    if (payload) {
      state.exits = payload;
    }
    //console.log('fetched exits', state.exits)
  },
  addEmployee: (state, payload) => {
    //console.log('payload data from store', payload)
    state.data = payload;
    //console.log('exit data', state.exits);
    //console.log('state data', state.data);
    // state.data.push(payload);
  },
  setFetching: (state, payload) => {
    state.isFetching = payload;
  },
  setSaving: (state, payload) => {
    state.isSaving = payload;
  },
  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {
  async fetchByLeAndName({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_by_le_and_name.get('', {
        params: {
          le_id: payload.le_id,
          key: payload.key
        }
      });
      commit("setFetching", false);
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
  async fetchByInstallation({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_by_installation.get('', {
        params: {
          employee_id: payload.data.employee_id,
          page:payload.data.page,
          limit:payload.data.limit
        }
      });
      commit("setFetching", false);
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
  async fetchSalaryRevisionData({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_salary_revision.get('', {
        params: {
          le_id: payload.data.le_id,
          page:payload.data.page,
          limit:payload.data.limit
        }
      });
      commit("setFetching", false);
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },

  async fetchByTaxOutside({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_taxoutside.get('', {
        params: {
          employee_id: payload.data.employee_id,
          page:payload.data.page,
          limit:payload.data.limit
        }
      });
      commit("setFetching", false);
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
  async fectchEditTaxOutside({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_taxoutsideedit.patch(`?content_id=${payload.content_id}&tax_amount=${payload.tax_amount}&month=${payload.month}&year=${payload.year}`
    );
      commit("setSaving", false);
      if(res.status == 200) {
        commit("editData", payload);
      }
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
  async deleteTaxtOutside({ commit }, payload) {
    
    try {
      commit("setDeleting", true);
      let res = await axios_instance_taxoutsidedelete.delete(`?content_id=${payload.content_id}`); 
      console.log('pppp') 
      commit("setDeleting", false); 
      commit("setDeleting", res.data.rows);
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
  
  async fetchEmployeeByID({ commit }, payload) {
    //console.log("[state/dashboard/oganisation/employeeDocument/fetchAll] Calling API...", payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance_employee_document_id.get(``, {
        params: {
          employee_id: payload.data.employee_id
        }
      });
      //console.log("Checking response", res);
      commit("setFetching", false);
      //console.log("[state/dashboard/payroll/itReports/fetchAll] res: ", res);
      //   if(res.status == 200) {
      //     commit("set", payload);
      //   }
      commit("set", res.data.rows);
      return res;
    } catch (error) {
      //console.log('error', error.response);
      throw errorHandler(error.response);
    }
  },

  async create({commit}, payload) {
    //console.log("Adding...", payload);
  try {
    commit("setSaving", true);
    let res = await axios_instance_employee_upload_document.post('/', payload);
    //console.log("Inside created file", res);
    commit("setSaving", false);
    //console.log("res: ", res);
    if(res.status == 200) {
      commit("addemployeedocument", payload);
    }
    return res;
  }catch (error){
    //console.log('error', error.response);
    throw errorHandler(error.response);
      
  }
  },
  async fetchByInstallationStatus({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_by_installmentPatch.patch(`?employee_id=${payload.employee_id}&status=${payload.status}&schedule_code=${payload.schedule_code}`
    );
      commit("setSaving", false);
      if(res.status == 200) {
        commit("addStatus", payload);
      }
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },

  async putEmployeeDocByID({ commit }, payload) {
    //console.log("[state/dashboard/oganisation/employeeDocument/fetchAll] Calling API...", payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance2.put(`/`, {
        // body: {
        //   employee_id: payload.data.employee_id
        // }
        params: {
          employee_id: payload.le_id,
          // "id": "f646be68-00a0-48aa-ae02-71c102668218",
          // "legal_entity_id": "4447eb28-a0c4-4abf-ac85-8e55134cd2ff",
          // "documents": {
          // "document_category_id": "f646be68-00a0-48aa-ae02-71c102668220",
          // "document_category": "Personal",
          // "location": "https://thrymr-paylief-logos.s3.ap-south-1.amazonaws.com/Wed%20Nov%2025%202020%2010%3A52%3A33%20GMT%2B0530%20%28India%20Standard%20Time%29-Screenshot%20from%202020-09-09%2014-47-55.png",
          // "modified_by": "f646be68-00a0-48aa-ae02-71c102668218",
          // "name": "Adhar Card"
          // }
          //employee_id: payload.data.employee_id
        }
      });
      //console.log("Checking response", res);
      commit("setFetching", false);
      //console.log("[state/dashboard/payroll/itReports/fetchAll] res: ", res);
      //   if(res.status == 200) {
      //     commit("set", payload);
      //   }
      commit("set", res.data.rows);
      return res;
    } catch (error) {
      //console.log('error', error.response);
      throw errorHandler(error.response);
    }
  },

  async deleteEmployeeDocByID({ commit }, payload) {
    //console.log("[state/dashboard/oganisation/employeeDocument/fetchAll] Calling API...", payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance_employee_delete.delete(`/`, { data: payload });
      //console.log("Checking delete response", res);
      commit("setFetching", false);
      //console.log("[state/dashboard/payroll/itReports/fetchAll] res: ", res);
      //   if(res.status == 200) {
      //     commit("set", payload);
      //   }
      commit("set", res.data.rows);
      return res;
    } catch (error) {
      //console.log('error', error.response);
      throw errorHandler(error.response);
    }
  },

 
}

export default {
  namespaced: true,
  state, mutations, actions
}